import styled from 'styled-components'

export const Wrapper = styled.ul`
  padding: 0;
  margin: 0;
`

export const Item = styled.li`
  text-align: center;
  list-style: none;

  span {
    display: block;
    font-size: 13px;
    line-height: 1.2;
    font-weight: 400;
  }

  svg {
    width: 30px;
    height: 30px;
    padding: 10px;
    border-radius: 100%;
    margin-bottom: 5px;
    background: ${props => props.theme.palette.general.greyLight};
    fill: ${props => props.theme.palette.primary.alphaDark};

    * {
      stroke: ${props => props.theme.palette.primary.alphaDark};
    }
  }
`
